import * as am5 from '@amcharts/amcharts5';
import { Root } from '@amcharts/amcharts5';
import { Injectable, } from '@angular/core';
import { IDatiqGraph } from '../models';
import { DatiqAmcharts5ChartXyService } from './datiq-amcharts-5-chart-xy.service';

@Injectable({
    providedIn: 'root',
})
export class DatiqAmcharts5ChartService {
    constructor(private _xy: DatiqAmcharts5ChartXyService) {}
    init(root: Root, settings: IDatiqGraph): am5.Chart {
        return this.createChart(root, settings);
    }
    /**
     * Creates the main chart for the graph
     *
     * @param root - root to build the chart
     * @param settings - settings for the graph
     * @returns - a chart
     */
    createChart(root: Root, settings: IDatiqGraph): am5.Chart {
        //TODO: When we create the Map graphs, we will need to add logic here for saying the Map vs XY
        return this._xy.create(root, settings);
    }

    update(root: Root, settings: IDatiqGraph): am5.Chart {
        return this._xy.update(root, settings);
    }
}
